import React from 'react';
import { Box, Link, Typography, Stack, } from '@mui/material';

const Footer: React.FC = () => {
    const lang = navigator.language.split("-")[0] || "en";
    const privacyPolicyUrl = `/privacy-policy-${lang}.html`;
    // console.log(lang)
    return (
        <Box sx={{ width: '100%', py: 4, mt: 1, backgroundColor: 'grey.100' }}>
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="space-between"
                alignItems="center"
                spacing={{ xs: 2, sm: 4 }}
                sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}
            >
                {/* Copyright */}
                <Typography variant="body2" color="text.secondary">
                    Flowenti Technologies © {new Date().getFullYear()}
                </Typography>

                {/* Links */}
                <Stack direction="row" spacing={3} justifyContent="center">
                    <Link href={privacyPolicyUrl} target="_blank"
                        rel="noopener noreferrer" variant="body2" color="text.secondary" underline="hover">
                        Privacy Policy
                    </Link>
                    {/* <Link href="#" variant="body2" color="text.secondary" underline="hover">
                        Privacy
                    </Link>
                    <Link href="#" variant="body2" color="text.secondary" underline="hover">
                        Contatti
                    </Link> */}
                </Stack>

                {/* Social Icons */}
                {/* <Stack direction="row" spacing={1} justifyContent="center">
                    <IconButton size="small" href="#" aria-label="Twitter">
                        <TwitterIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" href="#" aria-label="LinkedIn">
                        <LinkedInIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" href="#" aria-label="GitHub">
                        <GitHubIcon fontSize="small" />
                    </IconButton>
                </Stack> */}
            </Stack>
        </Box>
    );
};

export default Footer;